export const accounts = 'accounts';
export const accountBillings = 'accountBillings';
export const accountPricings = 'accountPricings';
export const billings = 'billings';
export const billingExportSched = 'billingExportSched';
export const contentProviders = 'contentProviders';
export const customers = 'customers';
export const jobs = 'jobs';
export const jobConfigs = 'jobConfigs';
export const jobConfigTemplates = 'jobConfigTemplates';
export const kiosks = 'kiosks';
export const marketing = 'marketing';
export const members = 'members';
export const moments = 'moments';
export const purchases = 'purchases';
export const uploads = 'uploads';
export const salesReport = 'salesReport';
export const photogHourlyReport = 'photogHourlyReport';
export const analyticsReport = 'analyticsReport';
export const catalogs = 'catalogs';
export const guests = 'guests';
export const accessCodePages = 'accessCodePages';

export const getResourceLabel = resource => {
  // override specific resource labels
  switch (resource) {
    case jobConfigs:
      return 'Products';
  }

  // convert camelCase resource name to a label
  return resource
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, str => str.toUpperCase());
}
